import React from 'react';
import TopNav from '../../components/TopNav';
import CatchLogin from '../../images/catch/catch_login.jpg';
import CatchLogin2x from '../../images/catch/catch_login@2x.jpg';

const Header = () => {
  return (
    <header>
      <TopNav />
      <div className="catch sub">
        <img
          src={ CatchLogin }
          srcSet={ `${ CatchLogin } 1x, ${ CatchLogin2x } 2x` }
          alt="ログイン"
        />
      </div>
    </header>
  );
}

export default Header;
